export function productReducer(state, action) {
  switch (action.type) {
    case "GET_INFO_PRODUCT":
      return action.payload;
    case "DUPLICATE_ITEM":
      return action.payload;
    case "REMOVE_ITEM":
      return state.filter((item, index) => index !== action.payload);
    case "CREATE_ITEM":
      return [...state, action.payload];
    default:
      return state;
  }
}
